import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sigv-loading-mask',
  templateUrl: './loading-mask.component.html',
  styleUrls: ['./loading-mask.component.scss'],
})
export class LoadingMaskComponent implements OnInit {
  constructor() {}
  @Input() isLoading = false;

  ngOnInit(): void {}
}
